/** Vite public env (replaces NEXT_PUBLIC_*) */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  baseUrl: import.meta.env.VITE_BASE_URL ?? "",
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL ?? "",
  devBaseUrl: import.meta.env.VITE_DEV_BASE_URL ?? "",
  wsBaseUrl: import.meta.env.VITE_WS_BASE_URL ?? "",
};
